module.exports = __webpack_public_path__ + "img/agenda_06.4a343fa1.jpg";